import { BusInformation } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    busInformations: [],
    totalItems: 0,
    loading: false
  },
  actions: {
    async fetch({ commit }, params) {
      const busInformations = await BusInformation.fetch(params)
      commit('changeState', { busInformations })
      return busInformations
    },
    async count({ commit }, params) {
      const totalItems = await BusInformation.count(params)
      commit('changeState', { totalItems })
      return totalItems
    },
    async create({ commit }, data) {
      await BusInformation.create(data)
    },
    async update({ commit }, { id, ...data }) {
      await BusInformation.update(id, data)
    },
    async delete({ commit }, id) {
      await BusInformation.remove(id)
    }
  },
  mutations: {
    setState(state, { attribute = '', data }) {
      state[attribute] = data
    }
  }
}
